<template>
  <div class="sky_img_rotate">
    <el-dialog
      @closed="close"
      class="imgrotate"
      width="600px"
      :show-close="false"
      :title="title"
      :append-to-body="append"
      :visible.sync="visibleImg"
      :close-on-click-model="false"
      :lock-scroll="false"
    >
      <!--<el-button @click= "onCancel" class="imgclose" type= "info" icon= "el-icon-close" circle></el-button>-->
      <div
        width="500px"
        height="500px"
        :autoplay="false"
        @change="getChange"
        style="transition: transform .3s;"
        :style="{transform:'rotate('+rotate+'deg)'}"
      >
        <a
          :href="file.url"
          :style="{background: 'url(' + getType +') no-repeat center center/contain'}"
          class="imgStyle"
          target="_blank"
        ></a>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <img
          src="../../../assets/left.png"
          @click="rotateLeft"
          class="rotate-img"
          alt=""
        >
        <img
          src="../../../assets/180.png"
          @click="rotateimg"
          class="rotate-img"
          alt=""
        >
        <img
          src="../../../assets/right.png"
          @click="rotateRight"
          class="rotate-img"
          alt=""
        >
        <a
          @click="download"
          v-if="isDownload"
        >
          <img
            src="../../../assets/down.png"
            alt=""
          >
        </a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isAssetTypeAnImage, download } from "@/common/util";
export default {
  name: "sky-img-rotate",
  props: [
    "imgUrl",
    "title",
    "append",
    "visible",
    "fileName",
    "file",
    "isDownload"
  ],
  data() {
    return {
      rotate: 0,
      visibleImg: false,
      index: 0,
      downurl: ""
    };
  },
  watch: {
    visible: {
      handler(val, oldValue) {
        this.visibleImg = val;
        this.rotate = 0;
      },
      immediate: true
    },
    file: {
      handler(val, oldValue) {
        if (val) {
        }
      },
      immediate: true
    }
  },
  methods: {
    download(e) {
      download({
        url: this.file.url,
        fileName: this.file.fileName
      });
      e.preventDefault();
    },
    close() {
      this.$emit("update:visible", this.visibleImg);
      this.rotate = 0;
    },
    getData(data) {
      let array =
        typeof data == "string"
          ? [
              {
                url: data
              }
            ]
          : data;
      let list = array[this.index];

      let pdf1 = list.url.substr(list.url.length - 7);
      let pdf2 = list.url.substr(list.url.length - 3);
      if (pdf1 == "pdf.png") {
        this.downurl = list.name;
      } else if (pdf2 == "pdf") {
        array[this.index]["name"] = list.url;
        array[this.index].url = ""; //当上传的格式为pdf时 展示替换的图片
        this.downurl = list.name;
      } else {
        this.downurl = list.url;
      }
      return array;
    },

    getChange(val) {
      this.rotate = 0;
      this.index = val;
      let list = this.imgList[this.index];
      let pdf1 = list.url.substr(list.url.length - 7);
      let pdf2 = list.url.substr(list.url.length - 3);
      if (pdf1 == "pdf.png") {
        this.downurl = list.name;
      } else if (pdf2 == "pdf") {
        this.imgList[this.index]["name"] = list.url;
        this.imgList[this.index].url = ""; //展示的pdf图片
        this.downurl = list.name;
      } else {
        this.downurl = list.url;
      }
    },
    onCancel() {
      this.$emit("on-cancel");
    },
    rotateLeft() {
      this.rotate -= 90;
    },
    rotateimg() {
      this.rotate += 180;
    },
    rotateRight() {
      this.rotate += 90;
    }
  },
  computed: {
    imgList() {
      if (this.imgUrl.length != 0) {
        return this.getData(this.imgUrl);
      } else {
        return this.imgUrl;
      }
    },
    getType() {
      if (!this.file.ossName) {
        return "";
      }
      const typeList = {
        txt: {
          img: "txt.png"
        },
        pdf: {
          img: "pdf.png"
        },
        doc: {
          img: "word.png"
        },
        docx: {
          img: "word.png"
        },
        zip: {
          img: "zip.png"
        },
        ppt: {
          img: "ppt.png"
        },
        rar: {
          img: "rar.png"
        },
        others: {
          img: "file.png"
        }
      };

      const type = this.file.ossName.split(".")[1]; // 截取的图片类型
      return isAssetTypeAnImage(type)
        ? this.file.url
        : (typeList[type] &&
            require(`../../../assets/${typeList[type].img}`)) ||
            require(`../../../assets/${typeList["others"].img}`);
    }
  }
};
</script>

<style lang="scss">
.imgStyle {
  width: 500px;
  height: 500px;
  margin: 0 auto;
  display: block;
}

.rotate-img {
  margin: 0 20px;
}
</style>

},
        }
    };
</script>

<style lang="scss">
.imgStyle {
  width: 500px;
  height: 500px;
  margin: 0 auto;
  display: block;
}

.rotate-img {
  margin: 0 20px;
}
</style>
